import { useNavigate } from "react-router";
import { XCircle } from "lucide-react";

import PageWrapper from "@/components/layout/page-wrapper";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";

const PaymentFailed = () => {
    const navigate = useNavigate();

    const handleNavigate = () => {
        navigate("/app/billing");
    };

    const handleRetry = () => {
        // In a real implementation, you might want to redirect to the payment page
        // with the same parameters to retry the payment
        navigate("/app/billing");
    };

    return (
        <PageWrapper pageTitle="Payment Failed" currentPage="Payment Failed">
            <div className="flex flex-col items-center justify-center h-full py-12">
                <Card className="bg-white p-8 max-w-md w-full mx-4 shadow-lg">
                    <div className="flex flex-col items-center justify-center">
                        <div className="bg-red-100 rounded-full p-4 mb-6">
                            <XCircle className="h-16 w-16 text-red-600" />
                        </div>
                        <h1 className="text-3xl font-bold text-gray-800 mb-4">Payment Failed!</h1>
                        <p className="text-gray-600 text-center max-w-sm mb-8">
                            Unfortunately, your payment could not be processed. Please check your payment details and try again.
                        </p>
                        <div className="flex gap-4">
                            <Button onClick={handleNavigate} variant="outline">
                                Back to Billing
                            </Button>
                            <Button onClick={handleRetry} className="bg-red-600 hover:bg-red-700">
                                Try Again
                            </Button>
                        </div>
                    </div>
                </Card>
            </div>
        </PageWrapper>
    );
};

export default PaymentFailed;